module.exports = __webpack_public_path__ + "img/m6.dd20a26b.jpg";